/**
 * Copies text to the clipboard using the Clipboard API.
 * Returns true on success, false if the API is unavailable or the operation fails.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  if (!navigator?.clipboard?.writeText) {
    return false;
  }

  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
